import { render, staticRenderFns } from "./CompanyMergeModal.vue?vue&type=template&id=4959c4a2&scoped=true&"
import script from "./CompanyMergeModal.vue?vue&type=script&lang=js&"
export * from "./CompanyMergeModal.vue?vue&type=script&lang=js&"
import style0 from "./CompanyMergeModal.vue?vue&type=style&index=0&id=4959c4a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959c4a2",
  null
  
)

export default component.exports